<script setup lang="ts">
type Props = {
  errorMessages?: string | string[] | null
  dynamicHeight?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  errorMessages: null,
})

const componentsClasses = computed(() => {
  return [
    'app-input-error',
    {
      'app-input-error--dynamic-height': props.dynamicHeight,
    },
  ]
})

const errorText = computed(() => {
  if (!props.errorMessages) return null

  if (Array.isArray(props.errorMessages)) {
    return props.errorMessages[0]
  }

  return props.errorMessages
})
</script>

<template>
  <div :class="componentsClasses" data-test-id="input-error">
    <the-transition-height>
      <div v-if="errorText" class="app-input-error__text">
        {{ errorText }}
      </div>
    </the-transition-height>
  </div>
</template>

<style lang="scss">
.app-input-error {
  display: flex;
  min-height: 18px;
  padding: 0;
  overflow: hidden;
  pointer-events: none;

  &__text {
    padding-top: 4px;
    overflow: hidden;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: var(--ui-color-red);
    overflow-wrap: break-word;
  }

  &--dynamic-height {
    min-height: 0;
  }
}
</style>
